import React from 'react';
import { Drawer, Typography } from 'antd';
var {
  Link,
  Paragraph,
  Text,
  Title
} = Typography;
export default function DocsQueryBuilder(_ref) {
  var {
    drawerVisible,
    closeDrawer
  } = _ref;
  return /*#__PURE__*/React.createElement(Drawer, {
    title: "Global Parameters",
    placement: "right",
    closable: true,
    onClose: closeDrawer,
    visible: drawerVisible
  }, /*#__PURE__*/React.createElement(Paragraph, null, "All official Cryptosheets functions support a common way for", /*#__PURE__*/React.createElement(Text, {
    code: true
  }, "filtering"), ", ", /*#__PURE__*/React.createElement(Text, {
    code: true
  }, "querying"), ",", ' ', /*#__PURE__*/React.createElement(Text, {
    code: true
  }, "sorting"), ", ", /*#__PURE__*/React.createElement(Text, {
    code: true
  }, "limiting"), " and", ' ', /*#__PURE__*/React.createElement(Text, {
    code: true
  }, "selecting"), " any data from sources that are integrated with our platform called global parameters."), /*#__PURE__*/React.createElement(Paragraph, null, "Global parameters are a powerful way to dynamically transform and format data to meet your specific needs."), /*#__PURE__*/React.createElement(Paragraph, null, "The most efficient Cryptosheets users learn to master the different ways that global parameters can help them shape and transform their data to save time and resources."), /*#__PURE__*/React.createElement(Title, {
    level: 4
  }, "Examples"), /*#__PURE__*/React.createElement(Paragraph, null, "Try a quick example to compare the results when using the `_fields` parameter:"), /*#__PURE__*/React.createElement(Paragraph, null, /*#__PURE__*/React.createElement(Text, {
    code: true,
    copyable: true
  }, "=CS.QUERY(\"Paradigm\",\"Benchmarks Info\")")), /*#__PURE__*/React.createElement(Paragraph, null, /*#__PURE__*/React.createElement(Text, {
    code: true,
    copyable: true
  }, "=CS.QUERY(\"Paradigm\",\"Benchmarks info\", {('_fields', 'name,category,description')})")), /*#__PURE__*/React.createElement(Paragraph, null, "See more examples", ' ', /*#__PURE__*/React.createElement(Link, {
    href: "https://docs.cryptosheets.com/functions/common/",
    target: "_blank"
  }, "here")), /*#__PURE__*/React.createElement(Title, {
    level: 4
  }, "Additional Resources"), /*#__PURE__*/React.createElement(Paragraph, null, /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Link, {
    href: "https://medium.com/cryptosheets/why-datetime-formatting-for-crypto-api-data-is-the-most-important-part-of-your-trading-analysis-93fef04ed9d8",
    target: "_blank"
  }, "Why Datetime Formatting for Crypto API Data is the Most Important Part of Your Analysis")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Link, {
    href: "https://www.youtube.com/playlist?list=PLBg8GR5ao-awDRFd9j6_o97ItUTKI3hcV",
    target: "_blank"
  }, "YouTube playlist for Global Arguments")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Link, {
    href: "https://app.cryptosheets.com/#/templates/194",
    target: "_blank"
  }, "Format dates helper template")))));
}